var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWomanHead(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "41px",
    viewBox: "0 0 42 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WomanHead") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WomanHead",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.32928409,37.6188551 C16.0659481,42.0106119 13.0827253,5.07574768 13.0827253,5.07574768 L0.990801664,16.2170692 C0.990801664,16.2170692 -3.40737988,33.2270982 6.32928409,37.6188551 Z",
    id: "Fill-154",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.094326,5.02452427 C24.3747541,3.21197265 27.6848343,3.79240939 29.9797564,6.86178883 C28.4501877,7.52174383 27.3608768,8.33505884 27.2180094,8.44402075 L27.2020464,8.45629121 L27.2020464,8.45629121 L25,10.4073388 C25.9390612,13.4646465 26.4027982,18.0105458 26.636056,22.5474959 L26.6783904,23.4251014 C26.848018,27.1815663 26.8699922,30.8654264 26.8839693,33.6225043 C25.6693516,36.5761506 25.0317758,38.7000999 19.0217451,40.3165816 C16.7256505,40.9354384 14.3381186,41.1633317 12.0318643,40.8787183 C9.55289492,40.5768863 6.98248816,39.7189948 5.54996898,36.794871 C2.28870191,30.0978476 4.44256054,17.7207112 9.50209637,10.2812622 C13.129113,4.93843126 17.6298648,3.14364519 21.094326,5.02452427 Z",
    id: "Combined-Shape",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.160800022,16.9857625 C-0.740264476,15.0563305 2.3071559,8.94744311 5.27358172,7.09056095 C11.47979,3.20914782 14.6284536,1.10030224 21.1586401,0.110095803 L22.7279097,0.0355852202 C32.2346464,-0.414419485 37.0133255,3.38856146 38.4712277,12.3004193 C38.6028438,13.0827805 39.9898757,16.7083086 40,17.3612566 L37.0436985,16.2034013 C37.1449417,21.4289462 35.5554234,13.5523932 30.0882905,13.9543582 C21.53324,9.93078673 14.4563401,6.72977286 0.160800022,16.9857625 Z",
    id: "Fill-157",
    fill: "#27427A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0047695,34.8762776 L11.0047695,34.8762776 C9.34499205,34.274098 8,31.6432718 8,29 L14,31.1818242 C14,33.8241387 12.6550079,35.4784573 11.0047695,34.8762776",
    id: "Fill-158",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,29.5004948 C33,31.9852666 30.990099,34 28.4950495,34 C26.009901,34 24,31.9852666 24,29.5004948 C24,27.0147334 26.009901,25 28.4950495,25 C30.990099,25 33,27.0147334 33,29.5004948",
    id: "Fill-159",
    fill: "#ED5353"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanHead);
export default __webpack_public_path__ + "static/media/WomanHead.d82fd00928732df6bf9b5288b4b50265.svg";
export { ForwardRef as ReactComponent };